module.exports = __webpack_public_path__ + "static/media/604.615d217f.png";